import { sortByKey } from '@semios/app-platform-common'
import { translate } from 'i18n/i18n'
import moment from 'moment-timezone'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { CommentTextarea } from '../CommentTextarea'
import type { TIcsDashboardData } from '../types'
import { NDVIBlockRow } from './NDVIBlockRow'
import { NDVILegend } from './NDVILegend'

export const NDVI = ({ data, resetKey }: { data: TIcsDashboardData['ndvi']; resetKey: number }) => {
  const selectedPropertyId = selectedFieldAssetsStore.useSelector((s) => s.property)
  const selectedProperty = fieldAssetStore.useSelector((s) => s.properties)?.[Number(selectedPropertyId)]

  if (!selectedProperty?.timezone) return null

  const { timezone } = selectedProperty
  const propertyBlocks = selectedProperty.blocks ?? {}

  return (
    <div>
      <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <h3>{translate.phrases.banyanApp('Crop Vegetation & Uniformity (NDVI)')}</h3>
        </div>
        <NDVILegend />
      </div>
      <div>
        {data
          .map((d) => ({
            ...d,
            blockName: propertyBlocks[d.block_id]?.name ?? '',
          }))
          .sort(sortByKey('blockName'))
          .map((block) => (
            <NDVIBlockRow
              key={block.block_id}
              block={block}
              blockName={block.blockName}
              imageDateMoment={moment.tz(block.current_image.image_date, timezone)}
              previousImageDateMoment={
                block.since_last_image?.previous_image_date
                  ? moment.tz(block.since_last_image.previous_image_date, timezone)
                  : null
              }
              lastMonthImageDateMoment={
                block.since_last_month?.previous_image_date
                  ? moment.tz(block.since_last_month.previous_image_date, timezone)
                  : null
              }
            />
          ))}
      </div>
      <CommentTextarea resetKey={resetKey} />
    </div>
  )
}
